import {Component, Injector} from '@angular/core';
import {Store as TagStore, TagState} from './state/store';
import {Tag} from './state/model';
import {TagService as TagService} from './state/service';
import {EntityDetailComponent} from '../../components/entity-detail/component';
import {FormBuilder} from '@angular/forms';
import {TagQuery} from './state/query';

@Component({
  templateUrl: '../../components/entity-detail/component.html',
  styleUrls: ['../../components/entity-detail/component.scss']
})
export class TagDetailComponent extends EntityDetailComponent<Tag, TagState, TagStore> {

  constructor(
    public injector: Injector,
    service: TagService,
    protected query: TagQuery,
    protected formBuilder: FormBuilder) {
    super(injector, service, query);
  }
}
